import { forwardRef, type Ref, type SVGProps } from "react";
const IconISOOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29 5H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1m-1 18H4V7h24z" />
    <path d="M10.25 11.26H8.79v6.73h1.46z" />
    <path d="M15.36 17.56a1.89 1.89 0 0 0 .31-2.56 3.55 3.55 0 0 0-1.32-.91 8 8 0 0 1-.92-.47 1 1 0 0 1-.28-.27.6.6 0 0 1-.09-.33.6.6 0 0 1 .22-.49.9.9 0 0 1 .63-.19q.361.002.71.09.466.118.91.3l.47-1.1a6.5 6.5 0 0 0-1-.35 3.8 3.8 0 0 0-1-.13 2.6 2.6 0 0 0-1.71.51 1.74 1.74 0 0 0-.62 1.41 1.66 1.66 0 0 0 .19.82 2 2 0 0 0 .5.63q.441.333.95.55.46.201.89.46.197.116.33.3a.54.54 0 0 1 .11.35.61.61 0 0 1-.25.53 1.3 1.3 0 0 1-.74.18 3.6 3.6 0 0 1-.88-.12 8.5 8.5 0 0 1-1.18-.43v1.32a4.3 4.3 0 0 0 1.95.41 2.94 2.94 0 0 0 1.82-.51" />
    <path d="M20.25 18.08a3.15 3.15 0 0 0 2.42-.9 3.57 3.57 0 0 0 .85-2.57 3.6 3.6 0 0 0-.84-2.56 3.15 3.15 0 0 0-2.42-.9 3.23 3.23 0 0 0-2.44.89A3.58 3.58 0 0 0 17 14.6a3.63 3.63 0 0 0 .85 2.58 3.16 3.16 0 0 0 2.4.9m-1.31-5.17a1.58 1.58 0 0 1 1.32-.57c1.15 0 1.73.76 1.73 2.27s-.58 2.27-1.74 2.27a1.55 1.55 0 0 1-1.31-.57 2.76 2.76 0 0 1-.44-1.7 2.8 2.8 0 0 1 .44-1.7" />
  </svg>
);
const ForwardRef = forwardRef(IconISOOutlineSVG);
ForwardRef.displayName = "IconISOOutline";
export { ForwardRef as IconISOOutline };
